import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Paperclip } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { ReceiptViewer } from "./ReceiptViewer";

// Shows the attached receipt of any document in one click.
export const ReceiptButton = ({ url, testId = "receipt-open" }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (!url) {
    return (
      <span className="text-[10px] text-muted-foreground" data-testid={`${testId}-none`}>
        {t("acct.noReceipt")}
      </span>
    );
  }

  return (
    <>
      <NeuButton className="px-3 py-1.5 text-[11px]" data-testid={testId} onClick={() => setOpen(true)}>
        <Paperclip className="h-3 w-3" /> {t("acct.viewReceipt")}
      </NeuButton>
      {open ? <ReceiptViewer url={url} onClose={() => setOpen(false)} /> : null}
    </>
  );
};
